export default __webpack_public_path__ + "static/testing-business-ideas-70f1a45514028f00f67f6c1d2f11a0f0.jpg";